import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/charts/references/references.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
